export default __webpack_public_path__ + "static/media/purple-transform-logo.89f74b90.png";